import React, {useReducer} from 'react' 
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CustomSnackbars from './CustomSnackbars'
import ShowDialog from './ShowDialog'
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import {InfoWinContext} from './infowinContext'
import {infowinReducer} from './infowinReducer'
import {SHOW_ALERT_APP,SHOW_MESS_APP,SHOW_DIALOG_APP,DIALOG_ANSWER} from '../types'

const useStyles = makeStyles( theme => ({    
    root: {
      textAlign: 'left',
    },
    content: {
      paddingLeft: theme.spacing(3),
     },
     title: {
      paddingLeft: theme.spacing(3),
      textAlign: 'left',
      color : '#000',
      backgroundColor : '#d9d9d9',
      fontSize: '75%',
    },
    dense: {
      marginTop: 16,
    },
    menuButton: {
      marginLeft: -18,
      marginRight: 10,
    },  
    clgrid: {
      margin: theme.spacing(2),
      fontSize: '75%',
      textAlign: 'left',
      fontWeight : 'bold',
    },
    divbutton: {
      fontSize: '75%',
      textAlign: 'left',
      fontWeight : 'bold',
    },
    button: {
      margin: theme.spacing(),
      display: 'block',
      width:'50%',
    },
  }));

export const InfoWinState = ({children}) => {
    const initialState = {
      curmessage : { open : false , mess : "" , draw: { vertical : 'top', horizontal: 'center' }},
      alertmessage : { open : false , typemess : "error", mess : ""},
      dialog : { open : false ,id : null, title : "", mess : "",statement : false},
      dialoganswer : {winDialogAnswer : false,userDialogAnswer:{id:null,answer:false}}
    }
  
    const [state, dispatch] = useReducer(infowinReducer, initialState)
    const draw = { vertical : 'top', horizontal: 'left' }    

    const messageWin = (mess , open = (mess.length ? true : false)) => {
      dispatch({
        type: SHOW_MESS_APP,
        payload: {open, mess, draw}
      })
      dispatch({
        type: DIALOG_ANSWER,
        payload: {winDialogAnswer:false,userDialogAnswer:{id:null,answer:false}}
      })

    }

    const messageWinClose = () => {
        dispatch({
            type: SHOW_MESS_APP,
            payload: {open:false, mess:"", draw}
          })
      };  

    const alertWin = (typemess = 'info', mess , open = (mess.length ? true : false)) => {
        dispatch({
          type: SHOW_ALERT_APP,
          payload: {open,typemess,mess}
        })
        dispatch({
          type: DIALOG_ANSWER,
          payload: {winDialogAnswer:false,userDialogAnswer:{id:null,answer:false}}
        })
    }
        
    const alertWinClose = () => {
        dispatch({
            type: SHOW_ALERT_APP,
            payload: {open : false, mess : "",typemess : state.alertmessage.typemess}
          })
      };  
  
    //messageWinExtended

   const dialogWin = (id, title, mess, statement = true, open = true) => {   
        dispatch({
          type: SHOW_DIALOG_APP,
          payload: {open,id,title,mess,statement}
        })
        dispatch({
          type: DIALOG_ANSWER,
          payload: {winDialogAnswer:false,userDialogAnswer:{id,answer:false}}
        })
    }

    const handleDialogAnswer = (answer) => {
        const cleaWin = {open : false,id:null,title:"",mess:''}
        dispatch({
          type: SHOW_DIALOG_APP,
          payload: {open : false,id:null,title:"",mess:'',statement:false}
        })
        dispatch({
          type: DIALOG_ANSWER,
          payload: {winDialogAnswer:true,userDialogAnswer:{id:state.dialoganswer.userDialogAnswer.id,answer:answer}}
        })

      }
  

    // alertWin = (mess,typemess='info') => 
    //   this.props.appAlertOpen({open : true,typemess,mess})

    const {curmessage,alertmessage,dialog,dialoganswer} = state
    const classes = useStyles();
    
  return (
    <InfoWinContext.Provider value={{
      messageWin,alertWin,dialogWin,curmessage,alertmessage,dialog,dialoganswer
    }}>
       {children}
       <Snackbar
            anchorOrigin={curmessage.draw}
            autoHideDuration={5000}
            open={curmessage.open}
            onClose={messageWinClose}
            ContentProps={{
            'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{curmessage.mess}</span>}
       >              
         <SnackbarContent
            message={<span id="message-id">{curmessage.mess}</span>}
            action={[
            <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={messageWinClose}
            >
                <CloseIcon className={classes.icon} />
            </IconButton>,
            ]}              
          />
        </Snackbar>            
        <CustomSnackbars 
            useropen={alertmessage.open}
            userClose = {alertWinClose}
            uservar = {alertmessage.typemess}
            usermess = {alertmessage.mess}
        />
        {<ShowDialog 
            open={dialog.open}
            title={dialog.title}
            message={dialog.mess}
            message={dialog.mess}
            statement={dialog.statement}
            onAnswer={handleDialogAnswer}
           />    }
    </InfoWinContext.Provider>
  )
}  
//export default withStyles(styles)(InfoWinState);